/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KoreaOutboundPicVo } from './KoreaOutboundPicVo';
import {
    KoreaOutboundPicVoFromJSON,
    KoreaOutboundPicVoFromJSONTyped,
    KoreaOutboundPicVoToJSON,
    KoreaOutboundPicVoToJSONTyped,
} from './KoreaOutboundPicVo';

/**
 * 
 * @export
 * @interface ResponseKoreaOutboundPicVo
 */
export interface ResponseKoreaOutboundPicVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseKoreaOutboundPicVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseKoreaOutboundPicVo
     */
    message?: string;
    /**
     * 
     * @type {KoreaOutboundPicVo}
     * @memberof ResponseKoreaOutboundPicVo
     */
    data?: KoreaOutboundPicVo;
}

/**
 * Check if a given object implements the ResponseKoreaOutboundPicVo interface.
 */
export function instanceOfResponseKoreaOutboundPicVo(value: object): value is ResponseKoreaOutboundPicVo {
    return true;
}

export function ResponseKoreaOutboundPicVoFromJSON(json: any): ResponseKoreaOutboundPicVo {
    return ResponseKoreaOutboundPicVoFromJSONTyped(json, false);
}

export function ResponseKoreaOutboundPicVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseKoreaOutboundPicVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : KoreaOutboundPicVoFromJSON(json['data']),
    };
}

export function ResponseKoreaOutboundPicVoToJSON(json: any): ResponseKoreaOutboundPicVo {
    return ResponseKoreaOutboundPicVoToJSONTyped(json, false);
}

export function ResponseKoreaOutboundPicVoToJSONTyped(value?: ResponseKoreaOutboundPicVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': KoreaOutboundPicVoToJSON(value['data']),
    };
}

